import ManageLayout from "../../components/ManageLayout";
import Tbl from "../../../input_types/Tbl/Tbl";

export default function Orders(){
    return <ManageLayout>
            <div>
                <h1>manage orders</h1>
                <Tbl
                    tblName={"wwAppOrders"}
                    listFlds={"sn,date,client__xpd__"}
                    btns={{
                        edit: 'stdEdit'
                    }}
                ></Tbl>
            </div>;        
        </ManageLayout>

}